export default __webpack_public_path__ + "static/inter-bold-webfont-c4da430dcde2e61b47e497bc20aeb27a.woff2";